import { 
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

const PreventBackNavigationWarningModal = ({ showBackWarning, setShowBackWarning }) => {
  return (
    <Dialog sx={{
      '& .MuiDialog-paper': {
        width: '400px',        
      }
    }} open={showBackWarning} onClose={() => setShowBackWarning(false)}>
      <DialogTitle sx={{ fontSize: '24px' }}>Warning</DialogTitle>
      <DialogContent sx={{ fontSize: '20px', textAlign: 'center' }}>
        Back is not allowed❗
      </DialogContent>
      <DialogActions>
        <Button sx={{ fontSize: '16px' }} onClick={() => setShowBackWarning(false)}>OK</Button>
      </DialogActions>
    </Dialog>
  )
}

export default PreventBackNavigationWarningModal;
